import React, { useEffect, useState } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Link from '../../components/Link';
import messages from '../../locale/jsonMessages';
import { confirmEmailChange } from '../../actions/manageUserVerification';
import cs from '../../components/commonStyle.css';
import s from './TrustAndVerification.css';

const EmailChangeConfirmation = ({ intl, token, email, isAuthenticated }) => {
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    let mounted = true;
    dispatch(confirmEmailChange(token, email)).then(result => {
      if (mounted) setStatus(result);
    });
    return () => { mounted = false; };
  }, [dispatch, token, email]);

  const confirmed = ['confirmed', 'alreadyConfirmed'].includes(status);
  const message = status === 'checking'
    ? messages.emailChangeChecking
    : confirmed
      ? messages.emailChangeConfirmed
      : status === 'email'
        ? messages.emailAlreadyExists
        : messages.emailChangeConfirmationFailed;

  return (
    <Grid fluid className="listingContainer">
      <Row>
        <Col xs={12} sm={10} smOffset={1} md={8} mdOffset={2} className={cs.spaceTop6}>
          <div className={cx(cs.commonBorderSection, 'whiteBgColor')}>
            <h2 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom4)}>
              {formatMessage(messages.changeEmailTitle)}
            </h2>
            <p>{formatMessage(message)}</p>
            <Link to={isAuthenticated ? '/user/edit' : '/login'} className={s.confirmationLink}>
              {formatMessage(isAuthenticated ? messages.backToProfile : messages.loginTabTitle)}
            </Link>
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

export default injectIntl(withStyles(cs, s)(EmailChangeConfirmation));
